import { Button } from "@/components/ui/button";
import { DashboardCard } from "./DashboardCard";

interface ClientItem {
  title: string;
  plan: string;
  main: string;
  sub: string;
  showUsage?: boolean;
}

interface ListCardProps {
  title: string;
  subtitle: string;
  items: ClientItem[] | React.ReactNode[];
  toggleCard?: boolean;
  setToggleCard?: (toggle: boolean) => void;
  showExpiringSubscriptions?: boolean;
  className?: string;
  showUsage?: boolean;
}

export function ListCard({
  title,
  subtitle,
  items,
  toggleCard,
  setToggleCard,
  showExpiringSubscriptions,
  showUsage = true,
  className,
}: ListCardProps) {
  const isClientItems =
    items.length > 0 &&
    typeof items[0] === "object" &&
    items[0] !== null &&
    "title" in items[0] &&
    "plan" in items[0] &&
    "main" in items[0] &&
    "sub" in items[0];

  return (
    <DashboardCard className={className}>
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <h2 className="text-lg leading-5 font-bold text-white">{title}</h2>
          <p className="text-black-500 text-xs leading-3 font-medium">
            {subtitle}
          </p>
        </div>
        {showExpiringSubscriptions && (
          <Button
            variant="minimal"
            className="p-1.5 text-xs leading-normal font-bold tracking-normal text-white hover:bg-white/30 hover:text-white"
            onClick={() => setToggleCard?.(toggleCard ? false : true)}
          >
            {toggleCard ? "Show top clients" : "Show expiring subscriptions"}
          </Button>
        )}
      </div>
      <div className="flex flex-col gap-5 py-2">
        {items.map((item, i) => (
          <div key={i} className="flex items-start gap-2">
            {isClientItems && (
              <span className="text-md leading-6 font-medium">{i + 1}.</span>
            )}
            <div className="w-full space-y-0.5">
              {isClientItems ? (
                <div className="flex justify-between">
                  <div className="flex flex-col">
                    <div className="text-md leading-6 font-bold">
                      {(item as ClientItem).title}
                    </div>

                    <div className="text-black-300 text-sm leading-5 font-medium">
                      {(item as ClientItem).plan}
                    </div>
                  </div>

                  <div className="flex flex-col items-end text-sm leading-5 font-medium -tracking-wide">
                    <span>{(item as ClientItem).main}</span>
                    <span className="text-black-300 text-right">
                      {(item as ClientItem).sub}
                      {showUsage && " used"}
                    </span>
                  </div>
                </div>
              ) : (
                <div>{item as React.ReactNode}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
}
